// assets
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import DomainIcon from '@mui/icons-material/Domain';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
    id: 'utilities',
    title: 'Pages',
    type: 'group',
    children: [
        {
            id: 'invoice',
            title: 'Invoice Generate',
            type: 'item',
            url: '/admin/invoice',
            icon: ReceiptIcon,
            breadcrumbs: false
        },
        {
            id: 'invoice-setting',
            title: 'Invoice Setting',
            type: 'item',
            url: '/admin/invoice-setting',
            icon: SettingsApplicationsIcon,
            breadcrumbs: false
        },
        {
            id: 'domain-hosting',
            title: 'Domain Hosting Management',
            type: 'item',
            url: '/admin/domain-hosting',
            icon: DomainIcon,
            breadcrumbs: false
        },
        {
            id: 'hr-expenses',
            title: 'Office Expenses (HR)',
            type: 'item',
            url: '/admin/hr-expenses',
            icon: AccountBalanceWalletIcon,
            breadcrumbs: false
        },
        {
            id: 'salesperson',
            title: 'Salesperson',
            type: 'item',
            url: '/admin/salesperson',
            icon: PeopleAltIcon,
            breadcrumbs: false
        },
        {
    id: 'hr-management',
    title: 'HR Management',
    type: 'item',
    url: '/admin/hr',
    icon: PersonAddIcon,
    breadcrumbs: false
}
    ]
};

export default utilities;